import { Stack } from "@mui/material";
import { Callout, Title } from "@src/appV2/redesign/system/ui-components";

import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { InHomeVisitCardSkeleton } from "../Card/Skeleton";
import { type VisitWithCaseData } from "../types";
import { InHomeVisitBookingCard } from "./Card";

interface InHomeVisitConfirmBookingContentProps {
  visit: VisitWithCaseData;
  isError: boolean;
  errorMessage?: string;
}

export function InHomeVisitConfirmBookingContent(props: InHomeVisitConfirmBookingContentProps) {
  const { visit, isError, errorMessage = "Error booking visit" } = props;
  const {
    patient,
    case: caseData,
    workplaceName,
    isVisitLoading,
  } = useInHomeVisitModalsDataContext();
  const specialties = caseData?.attributes.specialties ?? [];

  return (
    <Stack direction="column" alignItems="center" spacing={9}>
      <Title variant="h2" component="h2" sx={{ textAlign: "center", textWrap: "balance" }}>
        Book this in-home visit
      </Title>
      {isError && (
        <Callout
          iconType="remove"
          title={errorMessage}
          sx={(theme) => ({
            backgroundColor: theme.palette.intent?.error.background,
            color: theme.palette.intent?.error.text,
          })}
        />
      )}
      {isVisitLoading && <InHomeVisitCardSkeleton loadingLabel="Loading visit details" />}
      {!isVisitLoading && (
        <InHomeVisitBookingCard
          isPatientIdentifierHidden
          visit={visit}
          patient={patient}
          specialties={specialties}
          workplaceName={workplaceName}
        />
      )}
    </Stack>
  );
}
